import React, { useState } from 'react';
import { Menu } from 'semantic-ui-react';

import API from '../services/api.js';

class Wallet extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			wallet: null,
			ticker: null,
		}
	}

	componentDidMount () {
		API.Wallet.get()
			.then(wallet => {
				this.setState({
					wallet
				});
			})
			.catch(err => {
				console.error(err);
			});

		if (!this.state.ticker) {
			this.updateWallet();
		}
	}

	updateWallet() {
		this.setState({
			ticker: setTimeout(() => {
				API.Wallet.get()
					.then(wallet => {
						this.setState({
							wallet
						});
					})
					.catch(err => {
						console.error(err);
					})
					.finally(() => {
						this.updateWallet();
					});
			}, 2000)
		});
	}

	componentWillUnmount () {
		const { ticker } = this.state;

		clearInterval(ticker);

		this.setState({
			ticker: null
		});
	}

	render () {
		const { wallet } = this.state;

		return (wallet && !wallet.empty ? <Menu key={`wallet`} fluid vertical>
			<Menu.Item active={true} color={'green'}>${wallet.availableToWithdraw}</Menu.Item>
			<Menu.Item>${wallet.walletBalance}</Menu.Item>
			<Menu.Item>${wallet.cumRealisedPnl}</Menu.Item>
			<Menu.Item>${wallet.unrealisedPnl}</Menu.Item>
		</Menu> : <></>);
	}
}

export default Wallet;
